import { Router, ActivatedRoute } from '@angular/router';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AddEditAllProductsComponent } from './add-edit-all-products/add-edit-all-products.component';
import { ProductFilterComponent } from './product-filter/product-filter.component';
import { ExportComponent } from 'src/app/components/dashboard/distributor/export/export.component';
import { ImportComponent } from './import/import.component';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { ListColumn } from 'src/app/models/list-column.model';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, debounceTime, distinctUntilChanged } from 'rxjs';
import { PermissionService } from 'src/app/services/permission.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { routes } from 'src/app/app.routes';

@Component({
  selector: 'app-all-products',
  templateUrl: './all-products.component.html',
  styleUrls: ['./all-products.component.css'],
})
export class AllProductsComponent implements OnInit {
  exportData: any;
  searchValue: string | null = null;
  allProductData: any[] = [];
  showNoRecordsFounds = false;
  isRemovedFilter = false;
  isFilter = false;
  isSearch = false;
  searchKeyword = '';
  filterObject: any = {};
  filterPayload: any;
  selectedFilters: any[] = [];
  filteredData: any[] = [];
  showViewProduct: boolean = false;
  selectedViewData: any;
  searchControl: FormControl = new FormControl('');
  dataSource = new MatTableDataSource(this.allProductData);
  showPagination: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalEntries: number = 0;
  permissions = [];
  hasAddPermission: boolean = true;
  hasViewPermission: boolean = true;
  hasEditPermission: boolean = true;
  hasDeletePermission: boolean = true;
  debounceTimer: any;

  initialFilterProduct: any = {};
  isPagination: boolean = true;

  constructor(
    private dialog: MatDialog,
    private sweetAlertService: SweetAlertService,
    private allProductService: AllProductService,
    private localStorageService: LocalStorageService,
    private permissionService: PermissionService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.setBreadcrumbs(['Product Settings', 'All Products']);
    if (
      this.localStorageService.getItem('preferences') &&
      this.localStorageService.getItem('preferences').length > 0
    ) {
      this.updatePermissions();
    }
    const previousFilters = sessionStorage.getItem('productFilter');
    if (previousFilters === null || previousFilters === undefined) {
      this.filterObject = {};
    } else if (previousFilters) {
      this.filterObject = JSON.parse(previousFilters);
    }
    const search = sessionStorage.getItem('productSearch');
    if (search === null || search === undefined || search === '') {
      this.searchKeyword = '';
    } else if (search) {
      this.searchKeyword = search;
    }
    this.applySearch(this.searchKeyword);
  }

  onPageChanged(event: { pageIndex: number; pageSize: number }): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getAllProductInfoByFilter();
  }

  searchTermDebouncer(event: any) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(
      () => this.applySearch(event.target.value),
      450
    );
  }

  applySearch(keyword: string): void {
    this.pageIndex = 0;
    this.isSearch = true;
    this.isFilter = false;
    this.searchKeyword = keyword;
    if (this.searchKeyword) {
      sessionStorage.setItem('productSearch', this.searchKeyword);
    } else if (
      this.searchKeyword === '' ||
      this.searchKeyword === null ||
      this.searchKeyword === undefined
    ) {
      sessionStorage.removeItem('productSearch');
    }
    this.getAllProductInfoByFilter();
  }

  getAllProductsBySearchKeyword(filterValue: string): void {
    // this.filteredData = [];

    this.showNoRecordsFounds = false;
    this.allProductService
      .searchProducts(filterValue, this.pageIndex, this.pageSize)
      .subscribe((response: any) => {
        this.totalEntries = response?.totalCount;
        if (response.data.length > 0) {
          this.allProductData = response.data;
          this.allProductData = response.data.map(
            (item: any, index: number) => ({ ...item, srNo: index + 1 })
          );
          this.filteredData = this.allProductData;
          this.dataSource = new MatTableDataSource(this.filteredData);
          this.showPagination = true;
        } else {
          this.showNoRecordsFounds = true;
          this.showPagination = false;
        }
      });
  }

  openFilter() {
    const dialogRef = this.dialog.open(ProductFilterComponent, {
      height: 'auto',
      width: '912px',
      data: this.filterObject,
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.componentInstance.clearFilters.subscribe((clearingOptions) => {
      this.filterObject = clearingOptions;
      sessionStorage.removeItem('productFilter');
      this.getAllProductInfoByFilter();
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.filterObject = result;
      this.pageIndex = 0;
      if (this.filterObject) {
        sessionStorage.setItem(
          'productFilter',
          JSON.stringify(this.filterObject)
        );
        this.isSearch = false;
        this.pageIndex = 0;
      } else {
        sessionStorage.removeItem('productFilter');
        this.selectedFilters = [];
      }
      this.getAllProductInfoByFilter();
    });
  }

  openImport() {
    const data = this.prepareExportData();
    const dialogRef = this.dialog.open(ImportComponent, {
      height: 'auto',
      width: 'auto',
      data: {
        csvData: this.convertToCSV(data),
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getAllProductInfoByFilter();
    });
  }

  exportProductData() {
    const dialogRef = this.dialog.open(ExportComponent, {
      height: 'auto',
      width: 'auto',
      data: {
        title: 'Products',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Success') {
        this.sweetAlertService.showSuccess(
          result,
          'File downloaded Sucessfully!!'
        );
      }
    });
  }

  prepareExportData() {
    return this.filteredData.map((item) => ({
      productName: item.name,
      oemName: item.oemName,
      categoryName: item.categoryName,
      createdBy: item.createdByName,
      status: item.active ? 'Active' : 'Inactive',
    }));
  }

  convertToCSV(data: any[]): string {
    if (!data.length) {
      return '';
    }
    const camelCaseToTitleCase = (camelCase: string): string => {
      const result = camelCase.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    };
    const header = Object.keys(data[0])
      .map((key) => camelCaseToTitleCase(key))
      .join(',');
    const rows = data.map((item) => Object.values(item).join(','));
    return `${header}\n${rows.join('\n')}`;
  }

  getAllProductsInfo() {
    this.isFilter = false;
    this.isSearch = false;
    this.showNoRecordsFounds = false;
    this.allProductService
      .getAllProducts(this.pageIndex, this.pageSize)
      .subscribe((response: any) => {
        this.totalEntries = response?.totalCount;
        if (response.data.length > 0) {
          this.allProductData = response.data;
          this.allProductData = response.data.map(
            (item: any, index: number) => ({ ...item, srNo: index + 1 })
          );
          this.filteredData = this.allProductData;
          this.dataSource = new MatTableDataSource(this.filteredData);
          this.showPagination = true;
        } else {
          this.showNoRecordsFounds = true;
          this.showPagination = false;
        }
      });
  }

  getAllProductInfoByFilter() {
    this.showNoRecordsFounds = false;
    const filterObj = this.filterObject;
    let payload = {};
    let toDisplay = {};
    if (filterObj && filterObj.length !== 0 && filterObj !== undefined) {
      payload = {
        oemId: filterObj.oemId ? filterObj.oemId.id : '',
        categoryId: filterObj.categoryId,
        status: filterObj.status,
        createdBy: filterObj.createdBy?.id ? filterObj.createdBy?.id : '',
        startDate: filterObj.startDate,
        endDate: filterObj.endDate,
      };

      toDisplay = {
        oemName: filterObj.oemId ? filterObj.oemId.companyName : '',
        categoryName: filterObj.categoryName ? filterObj.categoryName : '',
        status: filterObj.status ? filterObj.status : '',
        createdByName: filterObj.createdBy?.name
          ? filterObj.createdBy?.name
          : '',
        startDate: filterObj.startDate ? filterObj.startDate : '',
        endDate: filterObj.endDate ? filterObj.endDate : '',
      };
    } else {
      payload = {};
      toDisplay = {};
    }
    this.filterPayload = payload;
    this.applyFilters(toDisplay);
    this.filterProduct(payload);
  }

  filterProduct(payload: any) {
    this.showNoRecordsFounds = false;
    this.isFilter = false;
    this.allProductService
      .getAllProductsWithFiltersAndSearch(
        this.pageIndex,
        this.pageSize,
        payload,
        this.searchKeyword
      )
      .subscribe(
        (response) => {
          if (response && response?.data && response.data.length > 0) {
            this.totalEntries = response.totalCount;
            this.allProductData = response.data.map(
              (item: any, index: number) => ({ ...item, srNo: index + 1 })
            );
            this.filteredData = this.allProductData;
            this.showNoRecordsFounds = false;
            const totalPages = Math.ceil(response?.totalCount / this.pageSize);
            if (this.pageIndex >= totalPages - 1) {
              this.isPagination = false;
            }
          } else {
            this.allProductData = [];
            this.filteredData = [];
            this.totalEntries = 0;
            this.showNoRecordsFounds = true;
            this.showPagination = false;
          }
        },
        (error) => {
          this.allProductData = [];
          this.filteredData = [];
          this.totalEntries = 0;
          this.showNoRecordsFounds = true;
          this.showPagination = false;
        }
      );
  }

  applyFilters(filterObj: any): void {
    if (this.isRemovedFilter) {
      this.selectedFilters = this.selectedFilters.filter(
        (f) => f.field !== filterObj.field
      );
      this.isRemovedFilter = false;
      const payloadAfterRemoved = this.filterPayload;
      switch (filterObj.field) {
        case 'oemName':
          payloadAfterRemoved.oemId = undefined;
          this.filterObject['oemId'] = '';
          break;
        case 'categoryName':
          payloadAfterRemoved.categoryId = undefined;
          this.filterObject['categoryId'] = '';
          break;
        case 'status':
          payloadAfterRemoved.status = undefined;
          this.filterObject['status'] = '';
          break;
        case 'createdByName':
          payloadAfterRemoved.createdBy = undefined;
          this.filterObject['createdBy'] = '';
          break;
        case 'startDate':
        case 'endDate':
        payloadAfterRemoved.startDate = undefined;
        payloadAfterRemoved.endDate = undefined;
        this.filterObject['startDate'] = '';
        this.filterObject['endDate'] = '';
        break;
        case 'dateRange':
          payloadAfterRemoved.startDate = undefined;
          payloadAfterRemoved.endDate = undefined;
          this.filterObject['startDate'] = '';
          this.filterObject['endDate'] = '';
          break;
        }
        this.filterProduct(payloadAfterRemoved);
        // this.filterObject = payloadAfterRemoved;
        // sessionStorage.setItem('productFilter', JSON.stringify(this.filterObject));
    } else {
      this.selectedFilters = [];
      for (const key in filterObj) {
        if (filterObj[key]) {
          if (key === 'startDate' && filterObj['endDate']) {
            const startDate = new Date(filterObj['startDate']);
            const endDate = new Date(filterObj['endDate']);
            const formattedStartDate = `${
              startDate.getMonth() + 1
            }/${startDate.getDate()}/${startDate.getFullYear()}`;
            const formattedEndDate = `${
              endDate.getMonth() + 1
            }/${endDate.getDate()}/${endDate.getFullYear()}`;
            this.selectedFilters.push({
              field: 'dateRange',
              value: `${formattedStartDate} - ${formattedEndDate}`,
            });
          } else if (key !== 'endDate') {
            this.selectedFilters.push({ field: key, value: filterObj[key] });
          }
        }
      }
    }
  }
  clearFilters(): void {
    this.pageIndex = 0;
    this.selectedFilters = [];
    this.filterObject = {};
    sessionStorage.removeItem('productFilter');
    this.getAllProductInfoByFilter();
  }
  removeFilter(filter: any): void {
    this.isRemovedFilter = true;
    this.applyFilters(filter);
  }
  openAddEditForm() {
    const dialogRef = this.dialog.open(AddEditAllProductsComponent, {
      height: 'auto',
      width: 'auto',
    });
    dialogRef.afterClosed().subscribe({
      next: (val) => {
        if (val) {
          this.getAllProductInfoByFilter();
        }
      },
    });
  }
  edit(id: any) {
    const dialogRef = this.dialog.open(AddEditAllProductsComponent, {
      width: 'auto',
      data: id,
    });
    dialogRef.afterClosed().subscribe({
      next: (val) => {
        if (val) {
          this.getAllProductInfoByFilter();
        }
      },
    });
  }
  delete(id: number) {
    this.sweetAlertService
      .showConfirmation(
        'Are you sure?',
        'You will not be able to recover the deleted record!',
        'Yes, Delete It',
        'Cancel'
      )
      .then((result) => {
        if (result.value) {
          this.allProductService.deleteProduct(id).subscribe((response) => {
            if (response.data) {
              this.getAllProductInfoByFilter();
              this.sweetAlertService.showSuccess(
                'Removed',
                'Product Info Deleted Successfully !!'
              );
            } else {
              this.sweetAlertService.showError(
                'Failed',
                'Failed to delete product info !!'
              );
            }
          });
        } else if (result.dismiss === this.sweetAlertService.CANCEL) {
          this.sweetAlertService.showError('Cancelled', 'Item is safe.');
        }
      });
  }
  columns: ListColumn[] = [
    { name: 'Sr No', property: 'srNo', visible: true, isModelProperty: false },
    {
      name: 'Name of Product',
      property: 'productName',
      visible: true,
      isModelProperty: true,
      isText: true,
    },
    {
      name: 'OEM Company',
      property: 'oemName',
      visible: true,
      isModelProperty: true,
      isText: true,
    },
    {
      name: 'Category Name',
      property: 'categoryName',
      visible: true,
      isModelProperty: true,
      isText: true,
    },
    {
      name: 'Created By',
      property: 'createdByName',
      visible: true,
      isModelProperty: true,
      isText: true,
    },
    {
      name: 'Created On',
      property: 'createdOn',
      visible: true,
      isModelProperty: true,
      isDatePipe: true,
    },
    {
      name: 'Status',
      property: 'active',
      visible: true,
      isModelProperty: true,
      isStatus: true,
    },
    {
      name: 'Actions',
      property: 'action',
      visible: true,
      isModelProperty: true,
      hasAction: true,
      actions: [
        {
          imageUrl: 'assets/images/eye-visble.svg',
          isImage: true,
          actionType: MweConstants.viewAction,
        },
        {
          imageUrl: 'assets/images/edit.svg',
          isImage: true,
          actionType: MweConstants.editAction,
          hasCondition: true,
          conditionProperty: 'active',
          conditionValue: true,
        },
        {
          imageUrl: 'assets/images/bin.svg',
          isImage: true,
          actionType: MweConstants.deleteAction,
          hasCondition: true,
          conditionProperty: 'active',
          conditionValue: true,
        },
      ],
    },
  ] as ListColumn[];
  data: any[] = [];
  updatePermissions() {
    this.permissions = this.localStorageService.getItem('preferences');
    this.hasAddPermission = this.permissionService.hasPermission(
      'ALL_PRODUCTS_CREATE',
      this.permissions
    );
    this.hasViewPermission = this.permissionService.hasPermission(
      'ALL_PRODUCTS_VIEW',
      this.permissions
    );
    this.hasEditPermission = this.permissionService.hasPermission(
      'ALL_PRODUCTS_EDIT',
      this.permissions
    );
    this.hasDeletePermission = this.permissionService.hasPermission(
      'ALL_PRODUCTS_DELETE',
      this.permissions
    );
    const columns = [
      {
        name: 'Sr No',
        property: 'srNo',
        visible: true,
        isModelProperty: false,
      },
      {
        name: 'Name of Product',
        property: 'name',
        visible: true,
        isModelProperty: true,
        isText: true,
      },
      {
        name: 'OEM Company',
        property: 'oemName',
        visible: true,
        isModelProperty: true,
        isText: true,
      },
      {
        name: 'Category Name',
        property: 'categoryName',
        visible: true,
        isModelProperty: true,
        isText: true,
      },
      {
        name: 'Created By',
        property: 'createdByName',
        visible: true,
        isModelProperty: true,
        isText: true,
      },
      {
        name: 'Created On',
        property: 'createdOn',
        visible: true,
        isModelProperty: true,
        isDatePipe: true,
      },
      {
        name: 'Status',
        property: 'active',
        visible: true,
        isModelProperty: true,
        isStatus: true,
      },
    ];
    if (
      this.hasAddPermission &&
      !this.hasViewPermission &&
      !this.hasDeletePermission &&
      !this.hasEditPermission
    ) {
      this.columns = columns;
    } else {
      const action: any = {
        name: 'Actions',
        property: 'action',
        visible: true,
        isModelProperty: true,
        hasAction: true,
        actions: [],
      };
      if (this.hasViewPermission) {
        action.actions.push({
          imageUrl: 'assets/images/eye-visble.svg',
          isImage: true,
          actionType: MweConstants.viewAction,
        });
      }
      if (this.hasEditPermission) {
        action.actions.push({
          imageUrl: 'assets/images/edit.svg',
          isImage: true,
          actionType: MweConstants.editAction,
          hasCondition: true,
          conditionProperty: 'active',
          conditionValue: true,
        });
      }
      if (this.hasDeletePermission) {
        action.actions.push({
          imageUrl: 'assets/images/bin.svg',
          isImage: true,
          actionType: MweConstants.deleteAction,
          hasCondition: true,
          conditionProperty: 'active',
          conditionValue: true,
        });
      }
      columns.push(action);
      this.columns = columns;
    }
  }
  selectedAction(event: any) {
    if (
      this.searchKeyword === '' ||
      this.searchKeyword === null ||
      this.searchKeyword === undefined
    ) {
      sessionStorage.removeItem('productSearch');
    } else if (this.searchKeyword) {
      sessionStorage.setItem('productSearch', this.searchKeyword);
    }
    if (this.filterObject === null || this.filterObject === undefined) {
      sessionStorage.removeItem('productFilter');
    } else if (this.filterObject) {
      sessionStorage.setItem(
        'productFilter',
        JSON.stringify(this.filterObject)
      );
    }
    switch (event.action) {
      case MweConstants.addAction:
        this.openAddEditForm();
        break;
      case MweConstants.editAction:
        this.edit(event.row.id);
        break;
      case MweConstants.deleteAction:
        this.delete(event.row.id);
        break;
      case MweConstants.filterAction:
        this.openFilter();
        break;
      case MweConstants.exportAction:
        // this.openExportData();
        break;
      case MweConstants.importAction:
        this.openImport();
        break;
      case MweConstants.viewAction:
        this.selectedViewData = event.row.id;
        this.showViewProduct = true;
        this.router.navigate(['view', this.selectedViewData], { relativeTo: this.activatedRoute });
        break;
      default:
        break;
    }
  }
  close(event: any) {
    this.showViewProduct = false;
    this.selectedViewData = null;
    this.getAllProductInfoByFilter();
  }
  closeToBack(event: any) {
    this.showViewProduct = false;
    this.selectedViewData = null;
    this.getAllProductInfoByFilter();
  }
}
